import $ from "jquery";
class Counter {
	constructor() {
		gsap.registerPlugin(ScrollTrigger);
		this.init()
	}

	init(){
		let numbers = document.querySelectorAll('.elementor-widget-bulb-keyNumbers .keyNumbers')


		var counters = $(".keyNumbers__title__number");
		var countersQuantity = counters.length;
		var counter = [];


		numbers.forEach((el,index)=>{

			gsap.set(el, {alpha: 0});

			let animatedNumber = el.querySelector('.keyNumbers__title__number');
			let destNumber = parseInt(animatedNumber.innerHTML);
			let gsapObj = {numberVal:0}

			ScrollTrigger.create({
				trigger: el,
				start: "top 100%",
				onEnter: self =>{
					gsap.fromTo(el,{alpha:0},{alpha: 1, duration: 2});
					gsap.fromTo(gsapObj,{numberVal:0},{
						duration:2,
						numberVal: destNumber,
						onUpdate:()=>{
							animatedNumber.innerHTML = Math.round(gsapObj.numberVal).toString();
						}
					})
				},
				onLeave:()=>{
					gsap.set(el, {alpha: 0});
				},
				onEnterBack:()=>{
					gsap.set(el, {alpha: 1});
				}
			});

		})


	}
}
module.exports = Counter;
